import React, { useState, useEffect, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import EditCreditPopup from '../CreditPolicy/EditCreditPopup';
import RetagInvoicePopup from '../CreditPolicy/RetagInvoicePopup';
import { Button } from "react-bootstrap";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import localization from 'assets/localization/localization';
import Images from "assets/images/imageData";
import ListFilters from "components/sales/ListFilters/ListFilters";

const EmployeeCreditPolicy = ({
    creditListing,
    creditsList = [],
    teamListing,
    teamsList = []
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [showEditCreditPopup, setShowEditCreditPopup] = useState(false);
  const [showRetagInvoicePopup, setShowRetagInvoicePopup] = useState(false);
  const [creditLimit, setCreditLimit] = useState("");
  const [creditExhausted, setCreditExhausted] = useState("");
  const [creditRemaining, setCreditRemaining] = useState("");
  const [responsibleEmail, setResponsibleEmail] = useState("");
  const [responsibleDepartment, setResponsibleDepartment] = useState("");
  const [departmentName, setDepartmentName] = useState(0);
  const [userName, setUserName] = useState('');
  const [type, setType] = useState('');
  const [monthlyAverageRevenue, setMonthlyAverageRevenue] = useState(0);
  const [employeeCreditLimit, setEmployeeCreditLimit] = useState(0);
  const [employeeCreditRemaining, setEmployeeCreditRemaining] = useState(0);
  const [userId, setUserId] = useState(0);
  const [departmentId, setDepartmentId] = useState(0);
  const [expectedCreditLimit, setExpectedCreditLimit] = useState(0);
  const [teamId, setTeamId] = useState(0);
  const [teamName, setTeamName] = useState("");
  const [employeeResponsibleEmail, setEmployeeResponsibleEmail] = useState("");
  const [employeeResponsibleDepartment, setEmployeeResponsibleDepartment] = useState("");
  const [employeeDepartmentId, setEmployeeDepartmentId] = useState("");
  const [employeeTeamId, setEmployeeTeamId] = useState(0);
  const [employeeTeamName, setEmployeeTeamName] = useState("");
  const [selectedTeam, setSelectedTeam] = useState(() => {
    const savedTeam = localStorage.getItem('selectedTeam');
    return savedTeam ? JSON.parse(savedTeam) : null;
  })
  const [selectedDepartment, setSelectedDepartment] = useState(() => {
    const savedDepartment = localStorage.getItem('selectedDepartment');
    return savedDepartment ? JSON.parse(savedDepartment) : null;
  })
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const EmployeeHeaders = [
    "Employee ID",
    "Employee Name",
    "Email",
    "Employee Status",
    "Department",
    "Team",
    "Credit Limit",
    "Credit Exhausted",
    "Credit Remaining",
    "Action"
  ];

  let current_type = 'E';

  useEffect(() => {
    const fetchData = async () => {
        setIsLoading(true);
        await teamListing();
        setIsLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!selectedTeam?.id || !selectedDepartment?.id) return;

    localStorage.setItem('selectedDepartment', JSON.stringify(selectedDepartment));
    localStorage.setItem('selectedTeam', JSON.stringify(selectedTeam));
  
    const fetchData = async () => {
      setIsLoading(true);
      if(filterData && filterData.employee_name != ''){
        await creditListing(current_type, 1, selectedDepartment?.id , selectedTeam?.id, filterData.employee_name);
      }
      else{
        await creditListing(current_type, 1, selectedDepartment?.id , selectedTeam?.id);
      }
      setIsLoading(false);
    };
  
    fetchData();
  }, [selectedTeam]);
  
  useEffect(() => {
    if (!creditsList || !creditsList?.resultSets || (creditsList?.resultSets?.length && !creditsList?.resultSets?.[0]?.user_id)) return;
  
    let tableData = [];

      tableData = [
        "id",
        "user_id",
        "employee_name",
        "email",
        "employee_status",
        "department_name",
        "team_name",
        "credit_limit",
        "credit_exhausted",
        "credit_remaining"
      ];
  
    const data = creditsList.resultSets.map((element) => {
      let actions = [];

        actions.push({
          name: 'Edit Credit Limit',
          creditLimit: element.credit_limit || "0.00",
          creditExhausted: element.credit_exhausted || "0.00",
          creditRemaining: element.credit_remaining || "0.00",
          departmentName: element.department_name || "",
          departmentId: element.department_id || 0,
          userId: element.user_id || 0,
          userName: element.employee_name || "",
          monthlyAverageRevenue: element.monthly_average_revenue || "0.00",
          type: 'E',
          responsibleEmail: element.email || '',
          responsibleDepartment: element.department_name || '',
          teamName: element.team_name || 0,
          teamId: element.team_id || '',
        });
        if (element?.employee_status != 'ACTIVE') {
          actions.push({
            name: 'Retag Invoice',
            employeeCreditLimit: element.credit_limit || "0.00",
            employeeCreditRemaining: element.credit_remaining || "0.00",
            employeeResponsibleEmail: element.email || '',
            employeeResponsibleDepartment : element.department_name || '',
            employeeDepartmentId: element.department_id || 0,
            employeeTeamId: element.team_id || 0,
            employeeTeamName: element.team_name || ''
          });
        }
  
      return {
        ...Object.fromEntries(tableData.map(key => [key, element[key]])),
        Action: actions
      };
    });
  
    data && setListData(data);
    setPageCount(Math.ceil(creditsList?.total / (creditsList?.per_page)));
  
  }, [creditsList]);     

  const onPageChange = async (val) => {
    setIsLoading(true);
    if(filterData && filterData.employee_name != ''){
      await creditListing(current_type,val.selected + 1,selectedDepartment?.id, selectedTeam?.id, filterData.employee_name);
    }
    else{
      await creditListing(current_type, val.selected + 1, selectedDepartment?.id , selectedTeam?.id);
    }
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
      localStorage.setItem("employee_credit_filter", JSON.stringify(filterData));
      setListData([]);
      setIsLoading(true);
      setFilterData(filterData);
      if(filterData && filterData.employee_name != ''){
        await creditListing(current_type, 1, selectedDepartment?.id , selectedTeam?.id, filterData.employee_name);
      }
      else{
        await creditListing(current_type, 1, selectedDepartment?.id , selectedTeam?.id);
      }
      localStorage.setItem("employeeFilterData",JSON.stringify(filterData));
      setIsLoading(false);
      filterToggle();
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          className="filter-hamburger btn btn-transparent">
          Total credit limit: {creditsList?.total_credit_limit ?? "0.00"}
        </Button>
        <Button
          className="filter-hamburger btn btn-transparent">
          Total credit exhausted: {creditsList?.total_credit_exhausted ?? "0.00"}
        </Button>
        <Button
          className="filter-hamburger btn btn-transparent">
          Total credit remaining: {creditsList?.total_credit_remaining ?? "0.00"}
        </Button>
      </Fragment>
    );
  };

  return (

    <>

    <Layout
      title="Employee Credits Listing"
      Buttons={headerBtns}
      className={false ? "requiredFileds" : ""}
      isLoading={isLoading}
    >

      <div className="row"> 
        
        <div className="mb-3 col-md-4">
        <DropDownInput
            label="Select Department"
            data={teamsList?.departments}
            getIdValue={(val) =>{
                setSelectedDepartment(val)
            }}
            value={selectedDepartment?.value || ''}
            isStarRequired={true}
        />
        </div>
      
        <div className="mb-3 col-md-4">
        <DropDownInput
            label="Select Team"
            data={teamsList?.teams}
            getIdValue={(val) =>{
                setSelectedTeam(val)
            }}
            value={selectedTeam?.value || ''}
            isStarRequired={true}
        />
        </div>

        <div className="mb-3 col-md-4">
          <Fragment>
            <Button
              onClick={filterToggle}
              className="filter-hamburger btn btn-transparent"
            >
              <img src={Images?.Filter} alt=""></img>
              {localization.showFilters}
            </Button>
          </Fragment>
        </div> 

      </div>  

      <TableSection
        data={listData}
        headers={EmployeeHeaders}
        pageCount={pageCount}
        setShowEditCreditPopup={setShowEditCreditPopup}
        setShowRetagInvoicePopup={setShowRetagInvoicePopup}
        setCreditLimit = {setCreditLimit}
        setCreditExhausted = {setCreditExhausted}
        setCreditRemaining = {setCreditRemaining}
        setType = {setType}
        setUserId = {setUserId}
        setMonthlyAverageRevenue = {setMonthlyAverageRevenue}
        setUserName = {setUserName}
        setDepartmentId = {setDepartmentId}
        setDepartmentName = {setDepartmentName}
        setResponsibleEmail={setResponsibleEmail}
        setEmployeeCreditLimit={setEmployeeCreditLimit}
        setEmployeeCreditRemaining={setEmployeeCreditRemaining}
        setResponsibleDepartment={setResponsibleDepartment}
        setEmployeeResponsibleEmail={setEmployeeResponsibleEmail}
        setEmployeeResponsibleDepartment={setEmployeeResponsibleDepartment}
        setEmployeeDepartmentId={setEmployeeDepartmentId}
        setTeamId={setTeamId}
        setTeamName={setTeamName}
        setExpectedCreditLimit={setExpectedCreditLimit}
        setEmployeeTeamId={setEmployeeTeamId}
        setEmployeeTeamName={setEmployeeTeamName}
        onPageChange={onPageChange}
        isId={false}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        employeeCreditFilter
      />

      <EditCreditPopup
        showEditCreditPopup={showEditCreditPopup}
        onClosePopup={() => setShowEditCreditPopup(false)}
        creditLimit = {creditLimit}
        creditExhausted = {creditExhausted}
        creditRemaining = {creditRemaining}
        userId={userId}
        departmentId={departmentId}
        departmentName={departmentName}
        userName={userName}
        type={type}
        monthlyAverageRevenue={monthlyAverageRevenue}
        responsibleEmail={responsibleEmail}
        responsibleDepartment={responsibleDepartment}
        teamId={teamId}
        teamName={teamName}
        expectedCreditLimit={expectedCreditLimit}
        />
        <RetagInvoicePopup
        showRetagInvoicePopup={showRetagInvoicePopup}
        onClosePopup={() => setShowRetagInvoicePopup(false)}
        employeeCreditLimit = {employeeCreditLimit}
        employeeCreditRemaining = {employeeCreditRemaining}
        employeeResponsibleEmail={employeeResponsibleEmail}
        employeeResponsibleDepartment={employeeResponsibleDepartment}
        employeeDepartmentId={employeeDepartmentId}
        employeeTeamId={employeeTeamId}
        employeeTeamName={employeeTeamName}
        />
    </Layout>
    </>
  );
};

export default EmployeeCreditPolicy;
